<template>
  <div class="bar">
    <div @click="onTab('list')" :class="'list' === activeIndex ? 'active' : ''">
      <i :class="'list' === activeIndex ? 'icon list active' : 'icon list'"></i>
    </div>
    <div @click="onTab('table')" :class="'table' === activeIndex ? 'active' : ''">
      <i :class="'table' === activeIndex ? 'icon table active' : 'icon table'"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      activeIndex: "list",
    };
  },
  methods: {
    onTab(index) {
      this.activeIndex = index;
      this.$emit("input", this.activeIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
//首页-排序栏
.bar {
  font-size: 0.3rem;
  margin: 0 0.1rem;
  padding: 0.1rem;
  text-align: center;

  display: flex;
  div {
    flex: 1;

    .icon {
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 1.5em;
      height: 1em;
      vertical-align: text-top;
      display: inline-block;
    }

    .icon.list {
      background-image: url(../assets/shengji/list.png);
    }
    .icon.table {
      background-image: url(../assets/shengji/table.png);
    }

    .icon.list.active {
      background-image: url(../assets/shengji/list-active.png);
    }
    .icon.table.active {
      background-image: url(../assets/shengji/table-active.png);
    }
  }
  div.active {
    color: #4fae54;
  }
}
</style>
